import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { SecondaryWordpressContent } from "../wordpress-content"

// this is not being used for now. June 27 2023
const NoFavoriteProgramsMessage = (): JSX.Element => {
  const query = useStaticQuery(graphql`
    query reusableBlockContent {
      wpReusableBlock(databaseId: { eq: 184961 }) {
        content
      }
    }
  `)

  return (
    <SecondaryWordpressContent html={query?.wpReusableBlock?.content || ``} />
  )
}

export default NoFavoriteProgramsMessage
